import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';
import {TIMEOUT_STORE} from 'util/constants';

const
    transformEntitiesFn = credential => {
        if (typeof credential !== 'object') {
            throw new Error('transformEntitiesFn needs an object to transform');
        }

        return {
            id:     credential.id,
            alias:  credential.alias,
            vendor: {
                selected: vendorCodes.vcloud,
                values:   {
                    service:           credential.service.id,
                    account:           credential.account.id,
                    username:          credential.username,
                    password:          credential.password,
                    host:              credential.host,
                    virtualDataCenter: credential.virtual_data_center,
                    organization:      credential.organization
                }
            }
        };
    },
    mapFields = {
        account:             'account',
        username:            'username',
        password:            'password',
        host:                'host',
        virtual_data_center: 'virtualDataCenter',
        organization:        'organization'
    },
    mapParametersToSave = {
        account:           'account',
        username:          'username',
        password:          'password',
        host:              'host',
        virtualDataCenter: 'virtual_data_center',
        organization:      'organization',
        service:           'service'
    },
    transformEntitiesToSaveFn = credential => Object.keys(credential.vendor)
        .reduce((ret, key) => ({
            ...ret,
            [mapParametersToSave[key]]: credential.vendor[key]
        }), {
            alias: credential.alias
        });

const exports = storeModuleFactory({
    name:             'vcloudCredentials',
    endpoint:         endpoints.securityCredentials.vcloud.endpoint,
    instanceEndpoint: endpoints.securityCredentials.vcloud.instanceEndpoint,
    callbackActions:  [{
        method: 'create',
        action: invalidateSecurityCredentials
    },{
        method: 'update',
        action: invalidateSecurityCredentials
    },{
        method: 'delete',
        action: invalidateSecurityCredentials
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/vcloudCredentials.js